import { Globe } from "lucide-react";
import { useCurrency } from "../context/CurrencyContext";
import { Select, SelectContent, SelectItem, SelectTrigger } from "./ui/select";

export default function CurrencySelector({ testid = "currency-selector", full = false }) {
  const { currency, setCurrency, currencies } = useCurrency();
  return (
    <Select value={currency} onValueChange={setCurrency}>
      <SelectTrigger
        data-testid={testid}
        className={`${full ? "w-full" : "w-auto"} gap-2 border-white/15 bg-transparent text-slate-200 hover:border-flame/50 h-9 rounded-full px-3.5 text-xs font-semibold tracking-wider [&>svg:last-child]:hidden`}
        aria-label="Select currency"
      >
        <Globe className="w-3.5 h-3.5 text-flame shrink-0" />
        <span data-testid={`${testid}-value`}>{currency}</span>
      </SelectTrigger>
      <SelectContent className="bg-navy-800 border-white/10">
        {currencies.map((c) => (
          <SelectItem key={c.code} value={c.code} data-testid={`currency-option-${c.code}`}>
            {c.code} — {c.name}
          </SelectItem>
        ))}
      </SelectContent>
    </Select>
  );
}
